// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"44":"2cddaff969c4da47","140":"b282a7059b808994","201":"bb398e3ba456e9ed","233":"f017a55bcb6feef4","354":"d963031d78f53b00","402":"e9952d1dfef39726","581":"6460b42de55c8b67","628":"961185778304a626","775":"d6178ba63faea3d1"}[chunkId] + ".js";
};